import React from 'react';
import CommonForm from '../../../global/form';
import SOURCES from '../../../../utils/constants';

const EnhancedSettingsBasics = ({
    form,
    settingMaxUploadLimit,
    settingAutomaticallyAcceptLead,
    setSettingAutomaticallyAcceptLead,
    settingOptions
}) => {

    const formData = [
        {
            label: "Max CSV Leads Upload Limit",
            name: "maxLeadCsvUploadLimit",
            inputType: SOURCES.FORMINPUTTYPES.INPUT,
            type: "text",
            placeholder: "Max Upload Limit",
            readOnly: true,
            initialValue: settingMaxUploadLimit,
            span: 12
        },
        {
            label: "Automatically Accept Leads (Imported via Lead Form)",
            name: "acceptLeadViaLeadForm",
            inputType: SOURCES.FORMINPUTTYPES.SELECT,
            type: "select",
            placeholder: "Select One",
            options: settingOptions.settingAutomaticallyAcceptLead.map(opt => ({
                label: opt.val,
                value: opt.id
            })),
            initialValue: settingAutomaticallyAcceptLead,
            span: 12,
            onChange: (value) => setSettingAutomaticallyAcceptLead(value)
        }
    ];

    return (
        <div className="">
            <CommonForm
                data={formData}
                form={form}
                layoutType="vertical"
            />
        </div >
    );
};

export default EnhancedSettingsBasics;
